import {Selector} from "@ngxs/store";
import {SearchGroupsState, SearchGroupsStateModel} from "@smatchy/domains/groups/state/search-groups.state";
import {GroundFoundDto} from "@smatchy/sdk";

export class SearchGroupsSelectors {
  @Selector([SearchGroupsState])
  static groups(state: SearchGroupsStateModel): GroundFoundDto[] {
    return state.groups;
  }

  @Selector([SearchGroupsState])
  static countFound(state: SearchGroupsStateModel): number {
    return state.groups.length;
  }

}
